export const GSTPercentage = 204
export const Rate = 203
export const MRPValue = 205


export const AdjustmentTypeID = 202
